import { createClient } from '@sanity/client';

export const sanityClient = createClient({
  projectId: 'kpo3uwto',
  dataset: 'production',
  // apiVersion: '2022-03-25',
  useCdn: true,
});
